<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="attendance-corrections" color="black"></help-link>
                    <v-chip v-if="frozenPeriod" label small class="warning" dark title="This period is already Frozen. You will not be able to change this record.">Frozen</v-chip>
                    <v-chip v-if="closedPeriod" label small class="grey darken-2" dark title="This period is already Closed. You will not be able to change this record.">Closed</v-chip>
                </v-toolbar>
            </v-card>
            <!-- <v-alert :value="true" color="info" icon="info" outline dismissible style="margin-top:5px;">
                To file an attendance correction, go to <b @click="$router.push('/myattendance/calendar')" style="text-decoration:underline; cursor:pointer;">My Calendar</b> to view your monthly attendance. Select the desired date by clicking the menu button, then click the "View Attendance Details" icon.
            </v-alert> -->
            <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin-top:5px;">
                {{ errorMessage }}
            </v-alert>
            <v-layout row wrap style="padding-bottom:10px;">
                <v-flex xs12>
                    <v-card class="elavation-1 transparent">
                        <v-toolbar flat height="45px">
                            <span class="font-weight-bold">Attendance Corrections Requests</span>
                            <v-spacer></v-spacer>
                            <span class="font-weight-bold">{{cutOffPeriod}}</span>                            
                        </v-toolbar>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-data-table
                                    :headers="headers"
                                    :items="attendance_corrections"
                                    :loading="loading"  
                                    :rows-per-page-items="rowsPerPageItems"
                                    :pagination.sync="paginationSync"
                                >
                                    <template v-slot:items="props">
                                        <tr @click="viewDetails(props.item)" style="cursor:pointer;">
                                            <td>
                                                {{ props.item.transDate | moment('YYYY-MM-DD (ddd)') }}
                                            </td>
                                            <td>{{ props.item.clockIn | moment('hh:mm a') }}</td>
                                            <td>{{ props.item.clockOut | moment('hh:mm a') }}</td>
                                            <td>{{ props.item.totalHours }}</td>
                                            <td>{{ props.item.chargeableHours }}</td>                                                
                                            <td>
                                                <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>  
</template>

<script>

import attCorrectionsApi from '@/api/attendancecorrection'
import commonfn from '@/common/functions'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'AttendanceCorrections',
    metaInfo: {
        title: 'My Attendance Corrections Report',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View summary of attendance corrections' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            rowsPerPageItems,
            error: false,
            errorMessage: '',
            loading: false,
            attendance_corrections: [],
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Date',align: 'left',value: 'transDate', width:'15%', sortable:true},
                {text: 'Clock-In',align: 'left',value: 'clockIn', width:'10%', sortable:true},
                {text: 'Clock-Out',align: 'left',value: 'clockOut', width:'10%', sortable:true},
                {text: 'Total Hours',align: 'left',value: 'totalHours', width:'10%', sortable:true},
                {text: 'Chargeable Hours',align: 'left',value: 'chargeableHours', width:'10%', sortable:true}, 
                {text: 'Status',align: 'left',value: 'status', width:'15%', sortable:true},
            ],
            cutoff_details: null
        }
    },
    methods: {  
        viewDetails(data) {
            this.$router.push(`details/${data.attendanceCorrectionsId}`)
        }, 
        async getAttendanceCorrections() {
            try {
                this.loading = true
                const response = await attCorrectionsApi.getByCutoffByUser(this.selectedCutOffId)
                if (response && response.status == 200) {
                    this.cutoff_details = response.data.cutoffItem
                    this.attendance_corrections = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'My Attendance Corrections',
            headerPageTitle: ''
        })
        this.getAttendanceCorrections()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        selectedCutOffId() {
            return this.$route.params.cutOffId
        },
        cutOffPeriod() {
            if (this.cutoff_details)
                return `${this.$moment(this.cutoff_details.cutoffStart).format('MMM DD, YYYY')} to ${this.$moment(this.cutoff_details.cutoffEnd).format('MMM DD, YYYY')}`
        },
        frozenPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Frozen')
        },
        closedPeriod() {
            if (this.cutoff_details)
                return this.cutoff_details.status==commonfn.getStatusCode('Closed')
        }
    }
}
</script>